import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Divider,
  VStack,
} from "@chakra-ui/react";
import { VicFormsRegistrationScreenComponent } from "./models";

const Success: React.FC<VicFormsRegistrationScreenComponent> = ({
  wizardData,
}) => {
  return (
    <VStack spacing={4} p={2} align={"stretch"} divider={<Divider />}>
      <Alert
        status="success"
        variant="subtle"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        height="200px"
      >
        <AlertIcon boxSize="40px" mr={0} />
        <AlertTitle mt={4} mb={1} fontSize="lg">
          Your account has been created!
        </AlertTitle>

        <AlertDescription maxWidth="sm">
          An email has been sent to{" "}
          <strong>{wizardData.ORGANISATION.userName}</strong> with a link to set
          up your password.
        </AlertDescription>
      </Alert>
    </VStack>
  );
};

export default Success;
